import React, { Component } from "react"
import { translate } from "react-translate"
import { Segment, Form, Dropdown, Button, Icon, Grid } from "semantic-ui-react"

import "./EditionParametreEntete.css"
import _ from "lodash"

const optionsStatuts = [
  { key: "france", text: "value_dropdown_france", value: "france" },
  { key: "chine", text: "value_dropdown_chine", value: "chine" },
  { key: "russie", text: "value_dropdown_russie", value: "russie" },
  { key: "angleterre", text: "value_dropdown_angleterre", value: "angleterre" }
]

const optionsJuridique = [
  { key: "SARL", text: "value_dropdown_SARL", value: "SARL" },
  { key: "EIRL", text: "value_dropdown_EIRL", value: "EIRL" },
  { key: "EURL", text: "value_dropdown_EURL", value: "EURL" },
  { key: "SAS", text: "value_dropdown_SAS", value: "SAS" },
  { key: "SASU", text: "value_dropdown_SASU", value: "SASU" }
]

class EditionParametreEntete extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    let { t } = this.props
    var optionsStatutsCopy = _.clone(optionsStatuts)
    optionsStatutsCopy = _.map(optionsStatutsCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })
    var optionsJuridiqueCopy = _.clone(optionsJuridique)
    optionsJuridiqueCopy = _.map(optionsJuridiqueCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      optionsStatuts: optionsStatutsCopy,
      optionsJuridique: optionsJuridiqueCopy
    })
  }

  render() {
    let { t } = this.props
    return (
      <Segment id="blocEntete">
        <Segment.Group id="premierBlocForm" horizontal>
          <Segment id="blocAddress">
            <Form>
              <Form.Field id="inputNomEntreprise">
                <label>{t("input_name_enterprise")}</label>
                <input
                  id="champInput"
                  placeholder={t("placeholder_name_enterprise")}
                />
              </Form.Field>
              <Form.Field id="fieldAdresse">
                <label id="labelAdresse">{t("input_adresse")}</label>
                <Segment id="blocAdresse">
                  <input
                    id="inputAdresse1"
                    placeholder={t("placeholder_numero")}
                  />
                  <input
                    id="inputAdresse1"
                    placeholder={t("placeholder_complement")}
                  />
                  <input
                    id="inputAdresse2"
                    placeholder={t("placeholder_postal")}
                  />
                  <input
                    id="inputAdresse3"
                    placeholder={t("placeholder_ville")}
                  />
                  <Dropdown
                    id="inputAdresse1"
                    placeholder={t("placeholder_france")}
                    fluid
                    selection
                    options={this.state.optionsStatuts || []}
                  />
                </Segment>
              </Form.Field>
            </Form>
          </Segment>
          <Segment id="blocSARL">
          <Form>
              <Form.Field id="fieldSARL">
                <label id="labelJuridique">{t("input_juridique")}</label>
                <Dropdown
                  id="dropdownJuridique"
                  placeholder={t("placeholder_juridique")}
                  fluid
                  selection
                  options={this.state.optionsJuridique || []}
                />
                <Form.Field id="inputTelephone">
                  <label>{t("input_telephone")}</label>
                  <input
                    id="champInput"
                    placeholder={t("placeholder_telephone")}
                  />
                </Form.Field>
                <Form.Field id="inputMailContact">
                  <label>{t("input_adresse_mail")}</label>
                  <input
                    id="champInput"
                    placeholder={t("placeholder_adresse_mail")}
                  />
                </Form.Field>
                <Form.Field id="inputSiteInternet">
                  <label>{t("input_site")}</label>
                  <input id="champInput" placeholder={t("placeholder_site")} />
                </Form.Field>
              </Form.Field>
            </Form>
          </Segment>

          <Segment id="secondBlocForm">
            <label>{t("label_block_entete")}</label>
            <Button id="btnLock">
              <Icon id="lockIcon" name="lock" link />
              {t("label_block_button_edit")}
            </Button>

            <Segment id="blocEnteteParDefaut">

                <p id="blocEnteteName">Peter Alvarado</p>
                <p className="blocEnteteNameDetails">357 Lotissement Assafsaf</p>
                <p className="blocEnteteNameDetails">Marrakech</p>
                <p className="blocEnteteNameDetails">40000 Marrakech</p>
                <p className="blocEnteteNameDetails">Maroc</p>
                <p className="blocEnteteNameDetails">tél : 227-173-0565</p>
                <p className="blocEnteteNameDetails">Email : issac.leffier@yahoo.com</p>
            </Segment>
          </Segment>

        </Segment.Group>


        <label id="labelBlocAjoutImage"> {t("label_add_image")} </label>
        <Segment id="blocAjoutImage">
          <Icon size="huge" id="imageIcon" name="image outline" link />
          <label id="labelImage">{t("add_image")}</label>
        </Segment>

      </Segment>
    )
  }
}

export default translate("ProParamHeader")(EditionParametreEntete)



// WEBPACK FOOTER //
// ./src/components/Pro/Parametres/Entete/EditionParametreEntete.js